"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeLogs = exports.getExposureLogs = exports.getEventLogs = exports.getEvaluationLogs = exports.getEmptyLogs = void 0;
const stableStringify_1 = __importDefault(require("./stableStringify"));
function getEmptyLogs() {
    return {
        evaluations: {},
        events: {},
        exposures: {},
    };
}
exports.getEmptyLogs = getEmptyLogs;
function getEvaluationLogs(expression) {
    if (expression.isTransient) {
        return getEmptyLogs();
    }
    return {
        evaluations: { [expression.id]: 1 },
        events: {},
        exposures: {},
    };
}
exports.getEvaluationLogs = getEvaluationLogs;
function getEventLogs(event) {
    return {
        evaluations: {},
        events: { [(0, stableStringify_1.default)(event)]: 1 },
        exposures: {},
    };
}
exports.getEventLogs = getEventLogs;
function getExposureLogs(exposure) {
    return {
        evaluations: {},
        events: {},
        exposures: {
            [(0, stableStringify_1.default)(exposure)]: 1,
        },
    };
}
exports.getExposureLogs = getExposureLogs;
function mergeLogs(a, ...bs) {
    return {
        evaluations: mergeCountMapsFromLogs("evaluations", a, bs),
        events: mergeCountMapsFromLogs("events", a, bs),
        exposures: mergeCountMapsFromLogs("exposures", a, bs),
    };
}
exports.mergeLogs = mergeLogs;
function mergeCountMapsFromLogs(countMapKey, a, bs) {
    const result = Object.assign({}, a[countMapKey]);
    bs.forEach((b) => {
        Object.entries(b[countMapKey]).forEach(([key, value]) => {
            result[key] = (result[key] || 0) + value;
        });
    });
    return result;
}
//# sourceMappingURL=reductionLogs.js.map